import { Link } from "react-router-dom";

/*
 RollLink — renders a roll_no as a link to /rolls/:id (or /rolls/:roll_no fallback).
 Backend supports both UUID and R-NNNNN lookup.
*/
export function RollLink({ id, rollNo, className = "" }) {
  const target = id || rollNo;
  if (!target || !rollNo) return <span>{rollNo || "-"}</span>;
  return (
    <Link
      to={`/rolls/${target}`}
      className={`text-zinc-950 font-semibold hover:underline hover:text-zinc-700 transition-colors ${className}`}
      data-testid={`roll-link-${rollNo}`}
    >
      {rollNo}
    </Link>
  );
}
